import React, { useState, useEffect } from "react";
import "./ArchiveHeader.scss";
import { useNavigate } from "react-router-dom";
import { useAccess } from "../../../context/AccessContext";
import { Image52 } from "../../../assets";
import { SupportSection } from "../../../../components";

const CONTRACT_ADDRESS = "0xf679a38273547875b1730ae995a1b0d856868843";

const ArchiveHeader = ({
  topImage,
  mainImage,
  description,
  years,
  isGateVerified,
}) => {
  const navigate = useNavigate();
  const { accessList, loading } = useAccess();
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    setHasAccess(accessList.includes(CONTRACT_ADDRESS.toLowerCase()));
  }, [accessList]);

  const isButtonEnabled = hasAccess || isGateVerified;
  const buttonText = loading
    ? "Checking..."
    : isButtonEnabled
    ? "View Full Collection"
    : "🔒 Locked";

  return (
    <section className="archive-section-component">
      <div
        className="asc-top-image"
        style={{ backgroundImage: `url(${topImage})` }}
      ></div>
      <SupportSection color="black" lineHeight="5px" />
      <div
        className="asc-main-image"
        style={{ backgroundImage: `url(${mainImage})` }}
      >
        <div className="asc-overlay" />
        <div className="asc-content">
          <div className="asc-left">
            <h2>Palestine Archive Collection</h2>
            {description && <p>{description}</p>}
          </div>

          <div className="asc-right">
            {years && <span className="asc-years">{years}</span>}
            <button
              className="asc-btn"
              disabled={loading || !isButtonEnabled}
              onClick={() => {
                if (!isButtonEnabled) {
                  alert("❌ You don’t have an access key for this archive.");
                  return;
                }
                navigate("/archive_Category");
              }}
            >
              {buttonText}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ArchiveHeader;
